import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  EDIT_AUTHORIZATION_PLANNING_REQUEST,
  EDIT_AUTHORIZATION_PLANNING_SUCCESS,
  EDIT_AUTHORIZATION_PLANNING_FAILURE,
  EDIT_AUTHORIZATION_PLANNING_LOADER,
  EDIT_AUTHORIZATION_PLANNING_RESET,
} = therapyPlanningAction;

function* editAuthorization(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: EDIT_AUTHORIZATION_PLANNING_LOADER });
    const response = yield call(therapyPlanningService.editAuthorization, payload?.payload);
    if (response?.status === 201 || response?.status === 200) {
      yield put({ type: EDIT_AUTHORIZATION_PLANNING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: EDIT_AUTHORIZATION_PLANNING_FAILURE, payload: error });
  }
}

function* editAuthorizationSaga() {
  yield takeEvery(EDIT_AUTHORIZATION_PLANNING_REQUEST, editAuthorization);
}

export default editAuthorizationSaga;
